export default "__VITE_ASSET__CRWnTZ1B__"